/**
 * Copyright (c) 2018-2023 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign } from "tslib";
import { ElementSphereVisual, ElementSphereParams, StructureElementSphereVisual } from '../visual/element-sphere';
import { UnitsRepresentation } from '../units-representation';
import { ParamDefinition as PD } from '../../../mol-util/param-definition';
import { ComplexRepresentation, StructureRepresentationProvider, StructureRepresentationStateBuilder } from '../representation';
import { Representation } from '../../../mol-repr/representation';
import { BaseGeometry } from '../../../mol-geo/geometry/base';
var SpacefillVisuals = {
    'element-sphere': function (ctx, getParams) { return UnitsRepresentation('Sphere mesh/impostor', ctx, getParams, ElementSphereVisual); },
    'structure-element-sphere': function (ctx, getParams) { return ComplexRepresentation('Structure sphere mesh/impostor', ctx, getParams, StructureElementSphereVisual); },
};
export var SpacefillParams = __assign(__assign({}, ElementSphereParams), { bumpFrequency: PD.Numeric(1, { min: 0, max: 10, step: 0.1 }, BaseGeometry.ShadingCategory), visuals: PD.MultiSelect(['element-sphere'], PD.objectToOptions(SpacefillVisuals)) });
var CoarseGrainedSpacefillParams;
export function getSpacefillParams(ctx, structure) {
    if (structure.isCoarseGrained) {
        if (!CoarseGrainedSpacefillParams) {
            CoarseGrainedSpacefillParams = PD.clone(SpacefillParams);
            CoarseGrainedSpacefillParams.sizeFactor.defaultValue = 2;
        }
        return CoarseGrainedSpacefillParams;
    }
    return SpacefillParams;
}
export function SpacefillRepresentation(ctx, getParams) {
    return Representation.createMulti('Spacefill', ctx, getParams, StructureRepresentationStateBuilder, SpacefillVisuals);
}
export var SpacefillRepresentationProvider = StructureRepresentationProvider({
    name: 'spacefill',
    label: 'Spacefill',
    description: 'Displays atomic/coarse elements as spheres.',
    factory: SpacefillRepresentation,
    getParams: getSpacefillParams,
    defaultValues: PD.getDefaultValues(SpacefillParams),
    defaultColorTheme: { name: 'element-symbol' },
    defaultSizeTheme: { name: 'physical' },
    isApplicable: function (structure) { return structure.elementCount > 0; }
});
